import request from '@/utils/request'

export function GenerateOrder (params) {
  return request({
    url: 'post/member/GenerateOrder',
    data: params
  })
}
export function QueryOrderPayState (params) {
  return request({
    url: 'post/member/QueryOrderPayState',
    data: params
  })
}

export function ApplyForTrialMembership () {
  return request({
    url: 'post/member/ApplyForTrialMembership'
  })
}

export function GetUpgradeableLevel () {
  return request({
    url: 'post/member/GetUpgradeableLevel'
  })
}

export function CalculatePriceDifference (params) {
  return request({
    url: 'post/member/CalculatePriceDifference',
    data: params
  })
}
export function GenerateUpgradeOrder (params) {
  return request({
    url: 'post/member/GenerateUpgradeOrder',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/member.js